var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BaseFrame from "../BaseFrame";
import { useAuth } from "../Security/AuthProvider";
import { Navigate } from "react-router-dom";
var AuthFrame = function (_a) {
    var appName = _a.appName, title = _a.title, icon = _a.icon, subTitle = _a.subTitle, onSignedInRedirectTo = _a.onSignedInRedirectTo, children = _a.children;
    var authContext = useAuth();
    if (authContext === null || authContext === void 0 ? void 0 : authContext.isSignedIn) {
        return _jsx(Navigate, { to: onSignedInRedirectTo, replace: true });
    }
    return (_jsx(BaseFrame, __assign({ title: title, appName: appName }, { children: _jsxs("div", __assign({ className: "flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8" }, { children: [_jsxs("div", __assign({ className: "sm:mx-auto sm:w-full sm:max-w-md" }, { children: [_jsx("img", { className: "mx-auto h-12 w-10", src: icon, alt: appName }), _jsx("h2", __assign({ className: "mt-6 text-center text-3xl font-bold tracking-tight text-gray-900" }, { children: title })), subTitle && subTitle] })), children] })) })));
};
export default AuthFrame;
